<mat-dialog-content class="mat-typography">
<app-text [alias]="'reg_staff_ip_grading_view_student'"></app-text>
<div>
    <table mat-table matSort [dataSource]="dataSource">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"
                class="header-row">
                Name (Last, First)
            </th>
            <td mat-cell *matCellDef="let student"><a href="mailto:{{student.emailAddress}}"> {{student.bannerLastName}}
                , {{student.bannerFirstName}}</a></td>
        </ng-container>
        <ng-container matColumnDef="studentId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Student ID"
                class="header-row">Student ID
            </th>
            <td mat-cell *matCellDef="let student">{{student.studentId}}</td>
        </ng-container>
        <ng-container matColumnDef="gradeBanner">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Banner Grade"
                class="header-row">Banner<br>Grade
            </th>
            <td mat-cell *matCellDef="let student">{{student.gradeBanner}}</td>
        </ng-container>
        <ng-container matColumnDef="gradeIGrade">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by IGrade"
                class="header-row">IGrade
            </th>
            <td mat-cell *matCellDef="let student">{{student.gradeIGrade}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator showFirstLastButtons id="rosterPaginator" class="do-not-show"></mat-paginator>
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <app-button-list>
        <app-button (clickedEvent)="onClose()" [icon]="'close'">Close </app-button>
    </app-button-list>
</mat-dialog-actions>
